import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-assign-venue',
  templateUrl: './assign-venue.component.html',
  styleUrls: ['./assign-venue.component.scss']
})
export class AssignVenueComponent implements OnInit { 
  AssignVenueForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  listdesc: any;
  clgname: any;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.AssignVenueForm = this.fb.group({
      AsVnlistNo: new FormControl(),
      AsVnlistNo2: new FormControl(),
      AsVnlistNo3: new FormControl('New'),
      AsVnValid: new FormControl(),
      AsVnChng: new FormControl(),
      AsVnVenue1: new FormControl(),
      AsVnRollNo: new FormControl(),
      AsVnTo: new FormControl(),
      AsVnVenue2: new FormControl(),
      EcId: new FormControl(),
     } );

    
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }
 
  getExmFrmList(id){
    const payload = {};
    payload['InCode'] = id;
    payload['SnNo'] = this.SessionNo;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
      } else {
      }
    });
  }

  deletee(e, k){
    if (e === 'true'){
      
      this.prepopulationForDelete(k);
    } else {
      
    }
  }

  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
  }

  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }

  prepopulation(data){
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
  }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
       this.AssignVenueForm.reset();
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }


  submit(){
    if (this.AssignVenueForm.invalid) {
      return;
    } else {
      this.submitAssignVenue();
    }
  }
  submitAssignVenue() {
    this.submitpayload = this.AssignVenueForm.value;
  }

  delete(){

  }

  update(){
    if (this.AssignVenueForm.invalid) {
      
      return;
    } else {
      this.updateAssignVenue();
    }
  }

  updateAssignVenue(){

  }

}
